import { render, staticRenderFns } from "./commonLineup.vue?vue&type=template&id=fada28ae&scoped=true"
import script from "./commonLineup.vue?vue&type=script&lang=js"
export * from "./commonLineup.vue?vue&type=script&lang=js"
import style0 from "./commonLineup.vue?vue&type=style&index=0&id=fada28ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fada28ae",
  null
  
)

export default component.exports